  $(document).ready(function(){

      $('.purchase-options-item button').click(function () {
    // Get the parent div of the clicked button
    var $parentItem = $(this).closest('.purchase-options-item');

    var isActive = $parentItem.hasClass('active');

    $('.purchase-options-item').removeClass('active');

    if (!isActive) {
      $parentItem.addClass('active');
    }
  });

    // Outer slider
    $('.discover-product-mobile-slider').owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      dots: true,
      items: 1,
      navText: [
        '<img src="https://cdn.shopify.com/s/files/1/0916/4629/6439/files/left-arrow.png?v=1745470601" alt="Précédent" />',
        '<img src="https://cdn.shopify.com/s/files/1/0916/4629/6439/files/right-arrow.png?v=1745470601" alt="Suivant" />'
      ],
      onInitialized: initInnerSliders,      // Init inner sliders after outer is ready
      onRefreshed: initInnerSliders         // Also re-init if owl refreshes
    });
    
    // Function to initialize inner sliders
    function initInnerSliders() {
      $('.single-discover-product-gallery.owl-carousel').each(function () {
        // Avoid double init by checking if Owl already exists
        if (!$(this).hasClass('owl-loaded')) {
          $(this).owlCarousel({
            loop: true,
            margin: 10,
            nav: true,
            dots: false,
            items: 1,
            mouseDrag:false,
            touchDrag:false,
            navText: [
              '<img src="https://cdn.shopify.com/s/files/1/0916/4629/6439/files/left-arrow.png?v=1745470601" alt="Précédent" />',
              '<img src="https://cdn.shopify.com/s/files/1/0916/4629/6439/files/right-arrow.png?v=1745470601" alt="Suivant" />'
            ]
          });
        }
      });
    }

    // 1. Initialize the outer carousel first
    $('.sensory-journey-product-slider').owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      dots: true,
      items: 1,
      navText: [
        '<img src="https://cdn.shopify.com/s/files/1/0916/4629/6439/files/left-arrow.png?v=1745470601" alt="Précédent" />',
        '<img src="https://cdn.shopify.com/s/files/1/0916/4629/6439/files/right-arrow.png?v=1745470601" alt="Suivant" />'
      ],
      onInitialized: initInnerCarousels // callback to init galleries
    });

    $('.sensory-journey-product-slider-2').owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      dots: true,
      items: 1,
      navText: [
        '<img src="https://cdn.shopify.com/s/files/1/0916/4629/6439/files/left-arrow.png?v=1745470601" alt="Précédent" />',
        '<img src="https://cdn.shopify.com/s/files/1/0916/4629/6439/files/right-arrow.png?v=1745470601" alt="Suivant" />'
      ],
      onInitialized: initInnerCarousels // callback to init galleries
    });
    
    // 2. Function to initialize each inner gallery AFTER the outer carousel is ready
    function initInnerCarousels() {
      $('.single-sensory-journey-product-gallery').each(function () {
        $(this).owlCarousel({
          loop: true,
          margin: 10,
          nav: false,
          dots: false,
          mouseDrag:false,
          touchDrag:false,
          items: 1,
          navText: [
            '<img src="https://cdn.shopify.com/s/files/1/0916/4629/6439/files/left-arrow.png?v=1745470601" alt="Précédent" />',
            '<img src="https://cdn.shopify.com/s/files/1/0916/4629/6439/files/right-arrow.png?v=1745470601" alt="Suivant" />'
          ]
        });
      });
    }

    // Review Slider
    $('.user-review-content').owlCarousel({
      loop: true,
      margin: 20,
      nav: true,
      dots: true,
      // autoplay: true,
      autoplayTimeout: 5000,
      navText: [
            '<img src="https://cdn.shopify.com/s/files/1/0916/4629/6439/files/left-arrow.png?v=1745470601" alt="Précédent" />',
            '<img src="https://cdn.shopify.com/s/files/1/0916/4629/6439/files/right-arrow.png?v=1745470601" alt="Suivant" />'
          ],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 3
        }
      }
    });    
  });

// Lot L10 (24/09/2026) : à la fin du chargement, les carrousels recalculent leur largeur
// (évite les cartes écrasées à la première visite sur mobile).
$(window).on('load', function () {
  $('.owl-carousel').trigger('refresh.owl.carousel');
});
